<style lang="scss" scoped>
.padhere {
  padding: 30px 20px;
}
.mrgn0 {
  margin: 0 !important;
}
.btn-info {
  background-color: dodgerblue !important;
}
.txthead {
  font-size: 20px !important;
}
.icolr {
  float: right;
  color: green;
  cursor: pointer;
  padding-left: 8px;
}
.icolrRed {
  color: rgb(172, 1, 1);
  cursor: pointer;
}
#products-spreadsheet {
  margin: 0;
  padding: 0;
  font-size: 20px;
  cursor: pointer;
  opacity: 0;
}
.txtblack {
  color: black;
  font-size: 14px;
}
.upDTIimg {
  width: 100%;
}

.file-upload-wrapper {
  position: relative;
  width: 100%;
  height: 60px;
  float: left;
}

.file-upload-wrapper:before {
  content: 'Choose File';
  position: absolute;
  top: 0;
  background: #4daf7c;
  color: #fff;
  font-weight: 400;
  z-index: 25;
  font-size: 16px;
  padding: 0 10px;
  text-transform: uppercase;
  pointer-events: none;
  border-radius: 2px;
  padding: 8px 20px;
}
.file-upload-wrapper:hover:before {
  background: #3d8c63;
}
.file-upload-wrapper input {
  opacity: 0;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 99;
  height: 40px;
  margin: 0;
  padding: 0;
  display: block;
  cursor: pointer;
  width: 100%;
}
select.optionShow {
  display: inline;
  background-color: transparent;
  border: none;
  border-bottom: 1px solid #9e9e9e;
  border-radius: 0;
  outline: none;
  font-size: 16px;
  margin: 0 0 8px 0;
  padding: 0;
}
table > tr > th {
  font-weight: 400 !important;
}
.errorMsg {
  color: red;
  margin: 0;
  font-size: 12px;
}
.pdd {
  margin: 40px;
}

.custom-image-wrapper {
  position: relative;
  width: fit-content;

  .remove-btn {
    position: absolute;
    width: 100%;
    height: 100%;

    span {
      position: absolute;
      right: 0;
      top: 0;
      color: #000;
      font-size: 20px;
      padding: 5px 10px;
      cursor: pointer;
    }
  }

  span {
    display: none;
  }
}

.txtblack {
  overflow-wrap: break-word;
}

.custom-image-wrapper:hover {
  .remove-btn {
    background-color: rgba(255, 255, 255, 0.5);

    span {
      display: block;
    }
  }
}

.vue-form-wizard {
  .wizard-tab-content {
    padding: 30px 10px 10px;
    .row {
      display: block;
    }
  }
}
</style>

<template lang="pug">
v-container(fluid)
  v-row
    //- .col.s12.m6
    //-     .row
    //-         div.col.s12.m6.push-m3
    //-             router-link(v-bind:to="{name: 'index'}")
    //-             img.responsive-img(src="/static/img/inomph_logo_md.png")
    //- .col.m2
    v-col(cols='12', sm='12')
      v-row(align='center', justify='center')
        //- .col.s12.m10.l8.xl6.offset-m1.offset-l2.offset-xl3
        v-col(cols='12', sm='12', md='10', lg='8', xl='6')
          .vertical-space-small
            .div
              form-wizard(
                @on-complete='onComplete',
                shape='circle',
                color='#3f51b5',
                title='Feeling thirsty? Register now!',
                subtitle='',
                back-button-text='Go back!',
                next-button-text='Go next!',
                finish-button-text='Finish',
                @on-validate='handleValidation'
              )
                tab-content(
                  title='Who are you?',
                  icon='fa fa-user',
                  :before-change='validateAsync'
                )
                  .row
                    .col.s12.m6.input-field
                      input#firstName(
                        type='text',
                        placeholder='ex. John',
                        name='hereFname',
                        v-model='registration.firstName',
                        required
                      )
                      //- input#firstName(type='text', placeholder='ex. John' name='hereFname' v-model='registration.Fname' prop="user" :rules="rules" ref="ruleForm")
                      p.errorMsg(v-if='errors.fname') {{ errors.fname }}
                      label.active(for='firstName') First Name *
                    .col.s12.m6.input-field
                      input#lastName(
                        type='text',
                        placeholder='ex. Doe',
                        name='Lname',
                        v-model='registration.lastName'
                      )
                      p.errorMsg(v-if='errors.lname') {{ errors.lname }}
                      label.active(for='lastName') Last Name *
                  .row
                    .col.s12.m6.input-field
                      input#username(
                        type='text',
                        placeholder='ex. John',
                        name='userName',
                        v-model='registration.username',
                        required
                      )
                      p.errorMsg(v-if='errors.username') {{ errors.username }}
                      label.active(for='username') Username *
                    .col.s12.m6.input-field
                      input#birthday.datepicker(
                        type='text',
                        name='birthday',
                        v-model='registration.birthday',
                        ref='datepicker',
                        placeholder='ex. yyyy-mm-dd'
                      )
                      p.errorMsg(v-if='errors.errbday') {{ errors.errbday }}
                      label.active(for='birthday') Birthday *
                  .row
                    .col.s12.m6.input-field
                      the-mask#contact(
                        mask='+63 ### ### ####',
                        placeholder='+63 ### ### ####',
                        v-model='registration.contact'
                      )
                      p.errorMsg(v-if='errors.errcontact') {{ errors.errcontact }}
                      label.active(for='contact') Contact Number *
                    .col.s12.m6.input-field
                      input#email(
                        type='email',
                        placeholder='ex. john.doe@gmail.com',
                        name='Lname',
                        v-model='registration.email'
                      )
                      p.errorMsg(v-if='errors.erremail') {{ errors.erremail }}
                      label.active(for='email') Email *
                  .row
                    .col.s12.m6.input-field
                      input#password(
                        type='password',
                        name='Lname',
                        v-model='registration.password'
                      )
                      p.errorMsg(v-if='errors.errpass') {{ errors.errpass }}
                      label.active(for='password') Password *
                    .col.s12.m6.input-field
                      input#vpassword(
                        type='password',
                        name='Lname',
                        @change='passwordcheck',
                        v-model='registration.passwordRepeat'
                      )
                      p.errorMsg(v-if='errors.errvpass') {{ errors.errvpass }}
                      label.active(for='passwordRepeat') Verify Password *
                tab-content(
                  title='What`s your business about?',
                  icon='fa fa-building',
                  :before-change='validateAsyncBusinessInfo'
                )
                  .row
                    .col.s12.m6.input-field
                      input#storeName(
                        type='text',
                        name='storeName',
                        v-model='registration.storeName'
                      )
                      p.errorMsg(v-if='errors.storeName') {{ errors.storeName }}
                      label.active(for='storeName') Store name *
                    .col.s12.m6.input-field
                      input#storeAddress(
                        type='text',
                        name='storeAddress',
                        v-model='registration.storeAddress'
                      )
                      p.errorMsg(v-if='errors.storeAddress') {{ errors.storeAddress }}
                      label.active(for='storeAddress') Store Address *
                  .row
                    .col.s12.m6.input-field
                      the-mask#storeTelNo(
                        mask='###-####',
                        placeholder='000-0000',
                        v-model='registration.storeTelNo'
                      )
                      //- input#storeTelNo(type='text', name='storeTelNo' v-model='registration.storeTelNo')
                      p.errorMsg(v-if='errors.storeTelNo') {{ errors.storeTelNo }}
                      label.active(for='storeTelNo') Store Tel No *
                    .col.s12.m6.input-field
                      input#businessName(
                        type='text',
                        name='businessName',
                        v-model='registration.businessName'
                      )
                      p.errorMsg(v-if='errors.businessName') {{ errors.businessName }}
                      label.active(for='businessName') Business Name *
                  .row
                    .col.s12.m6.input-field
                      input#mainOfficeAddress(
                        type='text',
                        name='mainOfficeAddress',
                        v-model='registration.mainOfficeAddress'
                      )
                      p.errorMsg(v-if='errors.mainOfficeAddress') {{ errors.mainOfficeAddress }}
                      label.active(for='mainOfficeAddress') Main Office Address *
                    .col.s12.m6.input-field
                      //- input#businessTelNo(type='text', name='businessTelNo' v-model='registration.businessTelNo')
                      the-mask#businessTelNo(
                        mask='###-####',
                        placeholder='XXX-XXXX',
                        v-model='registration.businessTelNo'
                      )
                      p.errorMsg(v-if='errors.businessTelNo') {{ errors.businessTelNo }}
                      label.active(for='businessTelNo') Business Tel No. *
                  .row
                    .col.s12.m6.input-field
                      select#typeOfOrganization.optionShow(
                        name='typeOfOrganization',
                        v-model='registration.typeOfOrganization'
                      )
                        option(value='Single Proprietorship') Single Proprietorship
                        option(value='Partnership') Partnership
                        option(value='Corporation') Corporation
                      p.errorMsg(v-if='errors.typeOfOrganization') {{ errors.typeOfOrganization }}
                      label.active(for='typeOfOrganization') Type of Organization *

                    .col.s12.m6.input-field
                      //- input#natureOfBusiness(type='text', name='natureOfBusiness' v-model='registration.natureOfBusiness')
                      //- label.active(for='natureOfBusiness')  Nature of Business
                      select#natureOfBusiness.optionShow(
                        name='natureOfBusiness',
                        v-model='registration.natureOfBusiness'
                      )
                        option(value='Wholesaler/Trader') Wholesaler/Trader
                        option(value='Grocery/Supermarket') Grocery/Supermarket
                        option(value='Restuarant/Bar') Restuarant/Bar
                        option(value='Hotel') Hotel
                        option(value='Wine House') Wine House
                      p.errorMsg(v-if='errors.natureOfBusiness') {{ errors.natureOfBusiness }}
                      label.active(for='natureOfBusiness') Nature of Business *
                  .row
                    .col.s12.m6.input-field
                      the-mask#tinNo(
                        mask='###-###-###-###',
                        placeholder='XXX-XXX-XXX-XXX',
                        v-model='registration.tinNo'
                      )
                      //- input#tinNo(type='text', name='tinNo' v-model='registration.tinNo')
                      p.errorMsg(v-if='errors.tinNo') {{ errors.tinNo }}
                      label.active(for='tinNo') TIN No *
                    .col.s12.m6.input-field
                      input#yearsOfOperation(
                        type='number',
                        min=0,
                        name='yearsOfOperation',
                        v-model='registration.yearsOfOperation'
                      )
                      p.errorMsg(v-if='errors.yearsOfOperation') {{ errors.yearsOfOperation }}
                      label.active(for='yearsOfOperation') Years of Operation *
                  .row
                    .col.s12.m6.input-field
                      input#secRegNo(
                        type='text',
                        name='secRegNo',
                        v-model='registration.secRegNo'
                      )
                      p.errorMsg(v-if='errors.secRegNo') {{ errors.secRegNo }}
                      label.active(for='secRegNo') SEC Reg No *
                    .col.s12.m6.input-field
                tab-content(
                  title='Getting to know more about your business',
                  icon='fa fa-info'
                )
                  .row
                    span.txthead Officers
                      i.material-icons.icolr(@click='addRow') add_circle_outline
                    ul.collapsible(data-collapsible='accordion')
                      li(v-for='(regOfficer, index) in registration.officers')
                        .collapsible-header.active
                          i.material-icons.icolrRed(@click='deleteRow(index)') delete_outline
                          | Officer Name: {{ regOfficer.fullname }}
                        .collapsible-body
                          .row
                            .col.s12.m6.input-field.mrgn0.mb-4
                              input#fullname.myfield(
                                type='text',
                                name='fullname',
                                v-model='regOfficer.fullname'
                              )
                              label.active(for='fullname') Name of owners/officer
                            .col.s12.m6.input-field.mrgn0.mb-4
                              input#position(
                                type='text',
                                name='position',
                                v-model='regOfficer.position'
                              )
                              label.active(for='position') Position
                          .row
                            .col.s12.m6.input-field.mrgn0.mb-4
                              input#residenceAddress(
                                type='text',
                                name='residenceAddress',
                                v-model='regOfficer.residenceAddress'
                              )
                              label.active(for='residenceAddress') Residence Address
                            .col.s12.m6.input-field.mrgn0.mb-4
                              the-mask#contactNo(
                                mask='+63 ### ### ####',
                                placeholder='+63 XXX XXX XXXX',
                                name='contactNo',
                                v-model='regOfficer.contactNo'
                              )
                              label.active(for='contactNo') Contact No.
                          .row
                            .col.s12.m6.input-field.mrgn0.mb-4
                              input#nationality(
                                type='text',
                                name='nationality',
                                v-model='regOfficer.nationality'
                              )
                              label.active(for='nationality') Nationality
                  .row
                    span.txthead Affiliates, Subsidiaries and Branches
                      i.material-icons.icolr(@click='addRowAffiliates') add_circle_outline
                    ul.collapsible(data-collapsible='accordion')
                      li(
                        v-for='(regAffiliates, index) in registration.Affiliates'
                      )
                        .collapsible-header.active
                          i.material-icons.icolrRed(
                            @click='deleteRowAffiliates(index)'
                          ) delete_outline
                          | Business Name: {{ regAffiliates.businessName }}
                        .collapsible-body
                          .row
                            .col.s12.m6.input-field
                              input#businessName(
                                type='text',
                                name='businessName',
                                v-model='regAffiliates.businessName'
                              )
                              label.active(for='businessName') Business Name
                            .col.s12.m6.input-field
                              input#address(
                                type='text',
                                name='address',
                                v-model='regAffiliates.address'
                              )
                              label.active(for='address') Address
                          .row
                            .col.s12.m6.input-field
                              //- input#businessType(type='text', name='businessType' v-model='regAffiliates.businessType')
                              select#businessType.optionShow(
                                name='businessType',
                                v-model='regAffiliates.businessType'
                              )
                                option(value='Wholesaler/Trader') Wholesaler/Trader
                                option(value='Grocery/Supermarket') Grocery/Supermarket
                                option(value='Restuarant/Bar') Restuarant/Bar
                                option(value='Hotel') Hotel
                                option(value='Wine House') Wine House
                              label.active(for='businessType') Type of Business
                tab-content(
                  title='Almost there!',
                  icon='fa fa-thumbs-up',
                  :before-change='validateAsyncBankInfo'
                )
                  .row
                    h6 Bank Information
                  .row
                    .col.s12.m6.input-field
                      input#bankName(
                        type='text',
                        name='bankName',
                        v-model='registration.bankName'
                      )
                      p.errorMsg(v-if='errors.bankName') {{ errors.bankName }}
                      label.active(for='bankName') Bank Name
                    .col.s12.m6.input-field
                      input#bankBranch(
                        type='text',
                        name='bankBranch',
                        v-model='registration.bankBranch'
                      )
                      p.errorMsg(v-if='errors.bankBranch') {{ errors.bankBranch }}
                      label.active(for='bankBranch') Branch
                  .row
                    .col.s12.m6.input-field
                      input#accountNumber(
                        type='number',
                        name='accountNumber',
                        v-model='registration.accountNumber'
                      )
                      p.errorMsg(v-if='errors.accountNumber') {{ errors.accountNumber }}
                      label.active(for='accountNumber') Account Number
                    .col.s12.m6.input-field
                      input#accountType(
                        type='text',
                        name='accountType',
                        v-model='registration.accountType'
                      )
                      p.errorMsg(v-if='errors.accountType') {{ errors.accountType }}
                      label.active(for='accountType') Account type
                  .row
                    .col.s12.m6
                      //- div(ref='photoSmall')
                      //-         p.center-align.no-margin-bottom.blue-text Your Thumbnail Photo
                      //-         p.center-align.no-margin-top 256x192
                      label Upload DTI
                      .file-upload-wrapper
                        input.file-upload-field(
                          name='dti',
                          ref='filedti',
                          @change='handleFileUploadDti()',
                          accept='.png, .jpg, .jpeg',
                          type='file',
                          value=''
                        )
                      p.errorMsg(v-if='errors.dti') {{ errors.dti }}
                        //- input(type='file' id='file' ref='file' accept='image/*' v-on:change='handleFileUpload()')

                    .col.s12.m6
                      label Upload 2303
                      .file-upload-wrapper
                        //- input.file-upload-field(name='dti'  @change="uploadImage"  accept='.png, .jpg, .jpeg' type='file' value='')
                        input#file(
                          type='file',
                          ref='file',
                          accept='image/*',
                          v-on:change='handleFileUpload()'
                        )
                      p.errorMsg(v-if='errors.photo2303') {{ errors.photo2303 }}
                  .row
                    .col.s12.m6
                      .custom-image-wrapper
                        .remove-btn
                          span(
                            @click='removeUpload("dti")',
                            v-show='showPreview1'
                          ) &#x2716;
                        img.upDTIimg(
                          v-bind:src='imagePreview1',
                          v-show='showPreview1'
                        )
                        //- img.upDTIimg(v-if='registration.previewImage ' :src='registration.previewImage ')
                    .col.s12.m6
                      .custom-image-wrapper
                        .remove-btn
                          span(@click='removeUpload()', v-show='showPreview') &#x2716;
                        img.upDTIimg(
                          v-bind:src='imagePreview',
                          v-show='showPreview'
                        )
                tab-content(title='Wrapping up', icon='fa fa-check')
                  .row
                    ul.collapsible(data-collapsible='accordion')
                      li
                        .collapsible-header.active
                          i.material-icons info_outline
                          | Who are You?
                        //- div.collapsible-body
                        .row.pdd
                          .col.s12.m6.input-field
                            .col.s12
                              label.active(for='firstName') First Name :
                            .col.s12
                              label.txtblack {{ registration.firstName }}
                          .col.s12.m6.input-field
                            .col.s12
                              label.active(for='lastName') Last Name :
                            .col.s12
                              label.txtblack {{ registration.lastName }}
                        .row.pdd
                          .col.s12.m6.input-field
                            .col.s12
                              label.active(for='contact') Contact Number:
                            .col.s12
                              label.txtblack {{ registration.contact }}
                          .col.s12.m6.input-field
                            .col.s12
                              label.active(for='email') Email:
                            .col.s12
                              label.active.txtblack {{ registration.email }}
                        .row.pdd
                          .col.s12.m6.input-field
                            .col.s12
                              label.active(for='password') Password:
                            .col.s12
                              label.txtblack {{ registration.password }}
                      li
                        .collapsible-header.active
                          i.material-icons info_outline
                          | "What's your Business about?"
                        //- div.collapsible-body
                        .row.pdd
                          .col.s12.m6.input-field
                            .col.s12
                              label.active(for='storeName') Store name :
                            .col.s12
                              label.txtblack {{ registration.storeName }}
                          .col.s12.m6.input-field
                            .col.s12
                              label.active(for='storeAddress') Store Address :
                            .col.s12
                              label.txtblack {{ registration.storeAddress }}
                        .row.pdd
                          .col.s12.m6.input-field
                            .col.s12
                              label.active(for='storeTelNo') Store Tel No :
                            .col.s12
                              label.txtblack {{ registration.storeTelNo }}
                          .col.s12.m6.input-field
                            .col.s12
                              label.active(for='businessName') Business Name :
                            .col.s12
                              label.txtblack {{ registration.businessName }}
                        .row.pdd
                          .col.s12.m6.input-field
                            .col.s12
                              label.active(for='mainOfficeAddress') Main Office Address :
                            .col.s12
                              label.txtblack {{ registration.mainOfficeAddress }}
                          .col.s12.m6.input-field
                            .col.s12
                              label.active(for='businessTelNo') Business Tel No. :
                            .col.s12
                              label.txtblack {{ registration.businessTelNo }}
                        .row.pdd
                          .col.s12.m6.input-field
                            .col.s12
                              label.active(for='typeOfOrganization') Type of Organization :
                            .col.s12
                              label.txtblack {{ registration.typeOfOrganization }}
                          .col.s12.m6.input-field
                            .col.s12
                              label.active(for='natureOfBusiness') Nature of Business :
                            .col.s12
                              label.txtblack {{ registration.natureOfBusiness }}
                        .row.pdd
                          .col.s12.m6.input-field
                            .col.s12
                              label.active(for='tinNo') TIN No. :
                            .col.s12
                              label.txtblack {{ registration.tinNo }}
                          .col.s12.m6.input-field
                            .col.s12
                              label.active(for='yearsOfOperation') Years of Operation :
                            .col.s12
                              label.txtblack {{ registration.yearsOfOperation }}
                        .row.pdd
                          .col.s12.m6.input-field
                            .col.s12
                              label.active(for='secRegNo') SEC Reg No. :
                            .col.s12
                              label.txtblack {{ registration.secRegNo }}
                      li
                        .collapsible-header.active
                          i.material-icons info_outline
                          | Getting to know more about your Business
                        //- div.collapsible-body
                        .row.pdd
                          .col.s12.m12.input-field
                            span.txthead Officer
                            table
                              tr
                                th Name
                                th Position
                                th Address
                                th Contact
                                th Nationality
                              tr(
                                v-for='(regOfficer, index) in registration.officers'
                              )
                                td {{ regOfficer.fullname }}
                                td {{ regOfficer.position }}
                                td {{ regOfficer.residenceAddress }}
                                td {{ regOfficer.contactNo }}
                                td {{ regOfficer.nationality }}
                        .row.pdd
                          .col.s12.m12.input-field
                            span.txthead Affiliates, Subsidiaries and Branches
                            table
                              tr
                                th Business Name
                                th Address
                                th Type of Business
                              tr(
                                v-for='(regAffiliates, index) in registration.Affiliates'
                              )
                                td {{ regAffiliates.businessName }}
                                td {{ regAffiliates.address }}
                                td {{ regAffiliates.businessType }}
                      li
                        .collapsible-header.active
                          i.material-icons info_outline
                          | Almost there!
                        //- div.collapsible-body
                        .row.pdd
                          .col.s12.m12
                            span.txthead Bank information
                        .row.pdd
                          .col.s12.m6.input-field
                            .col.s12
                              label.active(for='bankName') Bank Name :
                            .col.s12
                              label.txtblack {{ registration.bankName }}
                          .col.s12.m6.input-field
                            .col.s12
                              label.active(for='bankBranch') Bank Branch :
                            .col.s12
                              label.txtblack {{ registration.bankBranch }}
                        .row.pdd
                          .col.s12.m6.input-field
                            .col.s12
                              label.active(for='accountNumber') Bank Account Number:
                            .col.s12
                              label.txtblack {{ registration.accountNumber }}
                          .col.s12.m6.input-field
                            .col.s12
                              label.active(for='accountType') Bank Account Type :
                            .col.s12
                              label.txtblack {{ registration.accountType }}

                        .row.pdd
                          .col.s12.m6
                            .txthead DTI
                            img.upDTIimg(
                              v-bind:src='imagePreview1',
                              v-show='showPreview1'
                            )
                            //- img.upDTIimg(v-if='registration.previewImage ' :src='registration.previewImage ')
                          .col.s12.m6
                            .txthead 2303
                            img.upDTIimg(
                              v-bind:src='imagePreview',
                              v-show='showPreview'
                            )
                    label.custom-label
                      input(
                        type='checkbox',
                        name='above18',
                        v-model='registration.above18'
                      )
                      span.mb-5 I confirm that I am 18 years old or above.
</template>
<script>
import moment from 'moment'
import { FormWizard, TabContent } from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
export default {
  data() {
    return {
      errors: {
        fname: null,
        lname: null,
        username: null,
        errbday: null,
        errcontact: null,
        erremail: null,
        errpass: null,
        errvpass: null,
        storeName: null,
        storeAddress: null,
        storeTelNo: null,
        businessName: null,
        mainOfficeAddress: null,
        businessTelNo: null,
        typeOfOrganization: null,
        natureOfBusiness: null,
        tinNo: null,
        yearsOfOperation: null,
        secRegNo: null,
        bankName: null,
        bankBranch: null,
        accountNumber: null,
        accountType: null,
        photo2303: null,
        dti: null,
      },
      imagePreview1: null,
      showPreview1: false,
      imagePreview: null,
      showPreview: false,
      registration: {
        firstName: null,
        lastName: null,
        displayName: null,
        contact: null,
        email: null,
        birthday: null,
        username: null,
        password: null,
        passwordRepeat: null,
        storeName: null,
        storeAddress: null,
        storeTelNo: null,
        businessName: null,
        mainOfficeAddress: null,
        businessTelNo: null,
        typeOfOrganization: null,
        natureOfBusiness: null,
        tinNo: null,
        yearsOfOperation: null,
        secRegNo: null,
        officers: [
          {
            fullname: null,
            position: null,
            residenceAddress: null,
            contactNo: null,
            nationality: null,
          },
        ],
        Affiliates: [
          {
            businessName: null,
            address: null,
            businessType: null,
          },
        ],
        bankName: null,
        bankBranch: null,
        accountNumber: null,
        accountType: null,
        dti: null,
        photo2303: null,
        above18: false,
        previewImage: null,
      },
    }
  },
  mounted() {
    this.$M.Collapsible.init(document.querySelectorAll('.collapsible'))
    this.$M.Collapsible.init(document.querySelectorAll('.collapsible1'))
    // const maxDate = new Date(Date.now() - 567648000000) // 18 years old;
    const now = new Date()
    const from = now.getFullYear() - 100
    const to = new Date(now.getFullYear() - 18, now.getMonth(), now.getDate())
    this.$M.Datepicker.init(this.$refs.datepicker, {
      yearRange: [from, to.getFullYear()],
      maxDate: to,
      defaultDate: to,
      onSelect: this.birthdaySelected,
      format: 'yyyy-mm-dd',
    })
  },
  methods: {
    handleFileUploadDti() {
      this.registration.dti = this.$refs.filedti.files[0]
      let reader = new FileReader()
      reader.addEventListener(
        'load',
        function () {
          this.showPreview1 = true
          this.imagePreview1 = reader.result
        }.bind(this),
        false
      )

      if (this.registration.dti) {
        if (/\.(jpe?g|png|gif)$/i.test(this.registration.dti.name)) {
          reader.readAsDataURL(this.registration.dti)
        }
      }
      this.$refs.filedti.value = ''
    },
    handleFileUpload() {
      this.registration.photo2303 = this.$refs.file.files[0]
      let reader = new FileReader()
      reader.addEventListener(
        'load',
        function () {
          this.showPreview = true
          this.imagePreview = reader.result
        }.bind(this),
        false
      )

      if (this.registration.photo2303) {
        if (/\.(jpe?g|png|gif)$/i.test(this.registration.photo2303.name)) {
          reader.readAsDataURL(this.registration.photo2303)
        }
      }
      this.$refs.file.value = ''
    },

    removeUpload(u = '') {
      if (u === 'dti') {
        this.imagePreview1 = null
        this.showPreview1 = false
        this.registration.dti = null
      } else {
        this.imagePreview = null
        this.showPreview = false
        this.registration.photo2303 = null
      }
    },

    birthdaySelected(birthday) {
      this.registration.birthday = moment(String(birthday)).format('YYYY-MM-DD')
    },
    checkname() {
      if (!this.registration.firstName) {
        this.errors.fname = 'eroor'
      }
    },
    handleValidation(isValid, tabIndex) {},

    validateAsyncBusinessInfo() {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          if (
            this.registration.storeName &&
            this.registration.storeAddress &&
            this.registration.storeTelNo &&
            this.registration.businessName &&
            this.registration.mainOfficeAddress &&
            this.registration.businessTelNo &&
            this.registration.typeOfOrganization &&
            this.registration.natureOfBusiness &&
            this.registration.tinNo &&
            this.registration.yearsOfOperation &&
            this.registration.secRegNo
          ) {
            resolve(true)
          }

          this.errors.storeName = null
          this.errors.storeAddress = null
          this.errors.storeTelNo = null
          this.errors.businessName = null
          this.errors.mainOfficeAddress = null
          this.errors.businessTelNo = null
          this.errors.typeOfOrganization = null
          this.errors.natureOfBusiness = null
          this.errors.tinNo = null
          this.errors.yearsOfOperation = null
          this.errors.secRegNo = null

          if (!this.registration.storeName) {
            this.errors.storeName = 'Store name required'
            resolve(false)
          }

          if (!this.registration.storeAddress) {
            this.errors.storeAddress = 'Store address required'
            resolve(false)
          }

          if (!this.registration.storeTelNo) {
            this.errors.storeTelNo = 'Store tel no. required'
            resolve(false)
          }

          if (!this.registration.businessName) {
            this.errors.businessName = 'Business name required'
            resolve(false)
          }

          if (!this.registration.mainOfficeAddress) {
            this.errors.mainOfficeAddress = 'Main office address required'
            resolve(false)
          }

          if (!this.registration.businessTelNo) {
            this.errors.businessTelNo = 'Business tel no. required'
            resolve(false)
          }

          if (!this.registration.typeOfOrganization) {
            this.errors.typeOfOrganization = 'Type of organization required'
            resolve(false)
          }

          if (!this.registration.natureOfBusiness) {
            this.errors.natureOfBusiness = 'Nature of business required'
            resolve(false)
          }

          if (!this.registration.tinNo) {
            this.errors.tinNo = 'TIN no. required'
            resolve(false)
          }

          if (!this.registration.yearsOfOperation) {
            this.errors.yearsOfOperation = 'Years of operation required'
            resolve(false)
          }

          if (!this.registration.secRegNo) {
            this.errors.secRegNo = 'SEC registration no. required'
            resolve(false)
          }
        }, 1000)
      })
    },

    validateAsync() {
      return new Promise(async (resolve, reject) => {
        setTimeout(async () => {
          if (
            this.registration.firstName &&
            this.registration.lastName &&
            this.registration.username &&
            this.registration.birthday &&
            this.registration.contact &&
            this.validEmail(this.registration.email) &&
            this.registration.password &&
            this.registration.passwordRepeat &&
            this.registration.password === this.registration.passwordRepeat
          ) {
            resolve(true)
          }
          this.errors.fname = null
          this.errors.lname = null
          this.errors.username = null
          this.errors.errbday = null
          this.errors.errcontact = null
          this.errors.erremail = null
          this.errors.errpass = null
          this.errors.errvpass = null
          if (!this.registration.firstName) {
            this.errors.fname = 'First name required'
            resolve(false)
          }
          if (!this.registration.lastName) {
            this.errors.lname = 'Last name required'
            resolve(false)
          }
          if (!this.registration.username) {
            this.errors.username = 'Username required'
            resolve(false)
          }
          if (!this.registration.birthday) {
            this.errors.errbday = 'Birthday required'
            resolve(false)
          }
          if (!this.registration.contact) {
            this.errors.errcontact = 'Contact required'
            resolve(false)
          }

          if (!this.registration.email) {
            this.errors.erremail = 'Email required'
            resolve(false)
          } else if (!this.validEmail(this.registration.email)) {
            this.errors.erremail = 'Invalid email'
            resolve(false)
          }

          if (this.registration.email || this.registration.username) {
            await this.$http
              .post(`${this.$config.API_URL}/account/check-email-username`, {
                username: this.registration.username,
                email: this.registration.email,
              })
              .then((res) => {
                if (res.data) {
                  if (res.data.some((e) => e.field === 'username')) {
                    this.errors.username = 'Username already in used.'
                  }
                  if (res.data.some((e) => e.field === 'email')) {
                    this.errors.erremail = 'Email already in used.'
                  }
                  resolve(false)
                }
              })
          }

          if (!this.registration.password) {
            this.errors.errpass = 'Password required'
            resolve(false)
          }
          if (!this.registration.passwordRepeat) {
            this.errors.errvpass = 'Password repeat required'
            resolve(false)
          }
          if (
            this.registration.password &&
            this.registration.passwordRepeat &&
            this.registration.password !== this.registration.passwordRepeat
          ) {
            this.errors.errvpass = 'password not match'
            resolve(false)
          }
        }, 1000)
      })
    },
    validEmail(email) {
      var re =
        /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(email)
    },
    validateAsyncBankInfo() {
      return new Promise((resolve, reject) => {
        if (
          this.registration.bankName &&
          this.registration.bankBranch &&
          this.registration.accountNumber &&
          this.registration.accountType &&
          this.registration.photo2303 &&
          this.registration.dti
        ) {
          resolve(true)
        }

        this.errors.bankName = null
        this.errors.bankBranch = null
        this.errors.accountNumber = null
        this.errors.accountType = null
        this.errors.photo2303 = null
        this.errors.dti = null

        if (!this.registration.bankName) {
          this.errors.bankName = 'Bank name required.'
          resolve(false)
        }

        if (!this.registration.bankBranch) {
          this.errors.bankBranch = 'Bank branch required.'
          resolve(false)
        }

        if (!this.registration.accountNumber) {
          this.errors.accountNumber = 'Account number required.'
          resolve(false)
        }

        if (!this.registration.accountType) {
          this.errors.accountType = 'Choose account type.'
          resolve(false)
        }

        if (!this.registration.photo2303) {
          this.errors.photo2303 = 'Please upload an image'
          resolve(false)
        }

        if (!this.registration.dti) {
          this.errors.dti = 'Please upload an image'
          resolve(false)
        }
      })
    },
    firtsvalidate() {
      return new Promise((resolve, reject) => {
        this.$refs.ruleForm.validate((valid) => {
          resolve(true)
        })
      })
    },
    // register () {
    //   if (!this.registration.above18) {
    //     this.$snackbar.show({ text: 'You must confirm that you are 18 years old or above to register.' })
    //   } else {
    //     this.$http
    //       .post(`${this.$config.API_URL}/account/register-reseller`, this.registration)
    //       .then(data => {
    //         return this.$store
    //           .dispatch('auth/localLogin', {
    //             email: this.registration.email,
    //             password: this.registration.password,
    //             scope: 'customer'
    //           })
    //       })
    //       .then(user => {
    //         if (user.type !== 'customer') {
    //           this.$store.dispatch('auth/clear')
    //           throw new Error('Invalid account')
    //         }

    //         this.$snackbar.show({ text: 'Account Created Successfully.' })

    //         this.$router.replace('/')
    //       })
    //       .catch(err => {
    //         if (err.response && err.response.status === 400) {
    //           this.$snackbar.show({ text: 'Registration failed: ' + err.response.data.errors[0].messages[0] })
    //         } else {
    //           this.$snackbar.show({ text: 'Oops, there seems to be a problem: ' + err.message })
    //         }
    //       })
    //   }
    // },
    passwordcheck() {
      //   if (this.registration.password !== this.registration.passwordRepeat) {
      //     this.$snackbar.show({ text: 'Password not match!' })
      //   } else {
      //     this.$snackbar.show({ text: 'Password Match!' })
      //   }
    },
    addRow() {
      this.registration.officers.push({
        fullname: ' ',
        position: ' ',
        residenceAddress: ' ',
        contactNo: ' ',
        nationality: ' ',
      })
    },
    deleteRow(index) {
      this.registration.officers.splice(index, 1)
    },
    addRowAffiliates() {
      this.registration.Affiliates.push({
        businessName: ' ',
        address: ' ',
        businessType: ' ',
      })
    },
    deleteRowAffiliates(index) {
      this.registration.Affiliates.splice(index, 1)
    },
    // upload (e) {
    //   const fileReader = new FileReader()
    //   fileReader.onload = this.onFileLoaded
    //   fileReader.readAsArrayBuffer(e.target.files[0])
    // },
    // uploadImage (e) {
    //   const file = e.target.files[0]
    //   this.registration.previewImage = URL.createObjectURL(file)
    //   this.registration.dti = URL.createObjectURL(file)
    // },
    onComplete() {
      if (!this.registration.above18) {
        this.$snackbar.show({
          text: 'You must confirm that you are 18 years old or above to register.',
        })
      } else {
        // var rOfficers = [{ 'fullname': 'officer-A', 'position': 'Position-A', 'residenceAddress': 'Address-A', 'contactNo': '0900102840923', 'nationality': 'Amerikano' }, { 'fullname': 'officer-B', 'position': 'Position-B', 'residenceAddress': 'Address-B', 'contactNo': '090010283', 'nationality': 'Pnoy' }]
        // var rBranches = [{ 'businessName': 'Business-A', 'address': 'Address-A', 'businessType': 'Type-A' }, { 'businessName': 'Business-B', 'address': 'Address-B', 'businessType': 'Type-B' }, { 'businessName': 'Business-C', 'address': 'Address-C', 'businessType': 'Type-C' }]
        // var rOfficers = JSON.stringify(this.registration.officers)
        // var rBranches = JSON.stringify(this.registration.Affiliates)
        var formData = new FormData()
        formData.append('firstName', this.registration.firstName)
        formData.append('lastName', this.registration.lastName)
        formData.append('displayName', this.registration.username)
        formData.append('birthday', this.registration.birthday)
        formData.append('email', this.registration.email)
        formData.append('customertype', 'B2B')
        formData.append('phoneNumber', this.registration.contact)
        formData.append('username', this.registration.username)
        formData.append('password', this.registration.password)
        formData.append('passwordRepeat', this.registration.passwordRepeat)
        formData.append('storeName', this.registration.storeName)
        formData.append('storeAddress', this.registration.storeAddress)
        formData.append('storeTelNo', this.registration.storeTelNo)
        formData.append('businessName', this.registration.businessName)
        formData.append(
          'mainOfficeAddress',
          this.registration.mainOfficeAddress
        )
        formData.append('businessTelNo', this.registration.businessTelNo)
        formData.append(
          'typeOfOrganization',
          this.registration.typeOfOrganization
        )
        formData.append('natureOfBusiness', this.registration.natureOfBusiness)
        formData.append('tinNo', this.registration.tinNo)
        formData.append('yearsOfOperation', this.registration.yearsOfOperation)
        formData.append('secRegNo', this.registration.secRegNo)
        formData.append('bankName', this.registration.bankName)
        formData.append('bankBranch', this.registration.bankBranch)
        formData.append('accountNumber', this.registration.accountNumber)
        formData.append('accountType', this.registration.accountType)
        formData.append('above18', this.registration.above18)
        formData.append('dti', this.registration.dti)
        formData.append('2303', this.registration.photo2303)
        formData.append(
          'resellerOfficers',
          JSON.stringify(this.registration.officers)
        )
        formData.append(
          'resellerBranches',
          JSON.stringify(this.registration.Affiliates)
        )

        this.$http
          //   .post(`${this.$config.API_URL}/account/register-reseller`, this.registration)
          .post(`${this.$config.API_URL}/account/register-reseller`, formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          })
          .then((data) => {
            return this.$store.dispatch('auth/localLogin', {
              email: this.registration.email,
              password: this.registration.password,
              scope: 'reseller',
            })
          })
          .then((user) => {
            if (user.type !== 'reseller') {
              this.$store.dispatch('auth/clear')
              throw new Error('Invalid account')
            }

            this.$snackbar.show({
              text: 'Account Created Successfully.',
            })

            if (user.status === 'application') {
              this.$store.dispatch('auth/clear')
              this.$router.replace('/unauthorized')
            }

            this.$router.replace('/')
          })
          .catch((err) => {
            if (err.response && err.response.status === 400) {
              this.$snackbar.show({
                text:
                  'Registration failed: ' +
                  err.response.data.errors[0].messages[0],
              })
            } else {
              this.$snackbar.show({
                text: 'Oops, there seems to be a problem: ' + err.message,
              })
            }
          })
      }
    },
  },
  components: {
    FormWizard,
    TabContent,
  },
}
</script>



// WEBPACK FOOTER //
// src/components/page-register-reseller.vue